"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @deckee/app-main
 * App main integration endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jason@deckee.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberSettingToJSON = exports.MemberSettingFromJSONTyped = exports.MemberSettingFromJSON = exports.instanceOfMemberSetting = void 0;
var runtime_1 = require("../runtime");
var MemberSettingLocationConfig_1 = require("./MemberSettingLocationConfig");
var MemberSettingPaywallConfig_1 = require("./MemberSettingPaywallConfig");
var MemberSettingRiskForecastConfig_1 = require("./MemberSettingRiskForecastConfig");
var MemberSettingTripsConfig_1 = require("./MemberSettingTripsConfig");
var MemberSettingUnitsConfig_1 = require("./MemberSettingUnitsConfig");
var MemberSettingWaterBodyDefinitionConfig_1 = require("./MemberSettingWaterBodyDefinitionConfig");
var MemberSettingWeatherConfig_1 = require("./MemberSettingWeatherConfig");
var MemberSettingWeatherLayoutConfigInner_1 = require("./MemberSettingWeatherLayoutConfigInner");
/**
 * Check if a given object implements the MemberSetting interface.
 */
function instanceOfMemberSetting(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfMemberSetting = instanceOfMemberSetting;
function MemberSettingFromJSON(json) {
    return MemberSettingFromJSONTyped(json, false);
}
exports.MemberSettingFromJSON = MemberSettingFromJSON;
function MemberSettingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'unitsConfig': !(0, runtime_1.exists)(json, 'unitsConfig') ? undefined : (0, MemberSettingUnitsConfig_1.MemberSettingUnitsConfigFromJSON)(json['unitsConfig']),
        'tripsConfig': !(0, runtime_1.exists)(json, 'tripsConfig') ? undefined : (0, MemberSettingTripsConfig_1.MemberSettingTripsConfigFromJSON)(json['tripsConfig']),
        'weatherConfig': !(0, runtime_1.exists)(json, 'weatherConfig') ? undefined : (0, MemberSettingWeatherConfig_1.MemberSettingWeatherConfigFromJSON)(json['weatherConfig']),
        'locationConfig': !(0, runtime_1.exists)(json, 'locationConfig') ? undefined : (0, MemberSettingLocationConfig_1.MemberSettingLocationConfigFromJSON)(json['locationConfig']),
        'riskForecastConfig': !(0, runtime_1.exists)(json, 'riskForecastConfig') ? undefined : (0, MemberSettingRiskForecastConfig_1.MemberSettingRiskForecastConfigFromJSON)(json['riskForecastConfig']),
        'weatherLayoutConfig': !(0, runtime_1.exists)(json, 'weatherLayoutConfig') ? undefined : (json['weatherLayoutConfig'].map(MemberSettingWeatherLayoutConfigInner_1.MemberSettingWeatherLayoutConfigInnerFromJSON)),
        'waterBodyDefinitionConfig': !(0, runtime_1.exists)(json, 'waterBodyDefinitionConfig') ? undefined : (0, MemberSettingWaterBodyDefinitionConfig_1.MemberSettingWaterBodyDefinitionConfigFromJSON)(json['waterBodyDefinitionConfig']),
        'paywallConfig': !(0, runtime_1.exists)(json, 'paywallConfig') ? undefined : (0, MemberSettingPaywallConfig_1.MemberSettingPaywallConfigFromJSON)(json['paywallConfig']),
        'notificationConfig': !(0, runtime_1.exists)(json, 'notificationConfig') ? undefined : (0, MemberSettingPaywallConfig_1.MemberSettingPaywallConfigFromJSON)(json['notificationConfig']),
    };
}
exports.MemberSettingFromJSONTyped = MemberSettingFromJSONTyped;
function MemberSettingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'unitsConfig': (0, MemberSettingUnitsConfig_1.MemberSettingUnitsConfigToJSON)(value.unitsConfig),
        'tripsConfig': (0, MemberSettingTripsConfig_1.MemberSettingTripsConfigToJSON)(value.tripsConfig),
        'weatherConfig': (0, MemberSettingWeatherConfig_1.MemberSettingWeatherConfigToJSON)(value.weatherConfig),
        'locationConfig': (0, MemberSettingLocationConfig_1.MemberSettingLocationConfigToJSON)(value.locationConfig),
        'riskForecastConfig': (0, MemberSettingRiskForecastConfig_1.MemberSettingRiskForecastConfigToJSON)(value.riskForecastConfig),
        'weatherLayoutConfig': value.weatherLayoutConfig === undefined ? undefined : (value.weatherLayoutConfig.map(MemberSettingWeatherLayoutConfigInner_1.MemberSettingWeatherLayoutConfigInnerToJSON)),
        'waterBodyDefinitionConfig': (0, MemberSettingWaterBodyDefinitionConfig_1.MemberSettingWaterBodyDefinitionConfigToJSON)(value.waterBodyDefinitionConfig),
        'paywallConfig': (0, MemberSettingPaywallConfig_1.MemberSettingPaywallConfigToJSON)(value.paywallConfig),
        'notificationConfig': (0, MemberSettingPaywallConfig_1.MemberSettingPaywallConfigToJSON)(value.notificationConfig),
    };
}
exports.MemberSettingToJSON = MemberSettingToJSON;
